import { Svg } from '../../../../../components/Svg';
import { NotificationStatus, SeverityLevel } from '../../../../../types';
import WarningAmberOutlinedIcon from '@mui/icons-material/WarningAmberOutlined';
import { Variant } from '@weave-design/notifications-flyout';
import ErrorIcon from './Error.svg';
import InfoIcon from './Info.svg';
import SuccessIcon from './Success.svg';
import React from 'react';

export const isActive = (status: NotificationStatus | undefined) => {
	return status === NotificationStatus.ACTIVE;
};
export const isViewed = (status: NotificationStatus | undefined) => {
	return status === NotificationStatus.VIEWED;
};
export const isArchived = (status: NotificationStatus | undefined) => {
	return status === NotificationStatus.ARCHIVED;
};
export const isDeleted = (status: NotificationStatus | undefined) => {
	return status === NotificationStatus.DELETED;
};

export const getNotificationType = (severityLevel: SeverityLevel): Variant => {
	switch (severityLevel) {
		case SeverityLevel.ERROR:
			return 'error';
		case SeverityLevel.WARNING:
			return 'warning';
		case SeverityLevel.SUCCESS:
			return 'success';
		default:
			return 'primary';
	}
};

const NOTIFICATION_ICON_SIZE = 24;

const iconWrapperStyle: React.CSSProperties = {
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	width: NOTIFICATION_ICON_SIZE,
	height: NOTIFICATION_ICON_SIZE,
};

export const getNotificationIcon = (
	severityLevel: SeverityLevel,
): JSX.Element => {
	switch (severityLevel) {
		case SeverityLevel.ERROR:
			return (
				<span style={iconWrapperStyle}>
					<Svg svg={ErrorIcon} />
				</span>
			);
		case SeverityLevel.WARNING:
			return (
				<WarningAmberOutlinedIcon
					color="warning"
					sx={{
						width: NOTIFICATION_ICON_SIZE,
						height: NOTIFICATION_ICON_SIZE,
					}}
				/>
			);
		case SeverityLevel.SUCCESS:
			return (
				<span style={iconWrapperStyle}>
					<Svg svg={SuccessIcon} />
				</span>
			);
		default:
			return (
				<span style={iconWrapperStyle}>
					<Svg svg={InfoIcon} />
				</span>
			);
	}
};
